import { PropertyCarousel } from "./PropertyCarousel";

export const UniversalRender = PropertyCarousel;
